import { render } from "./ExternalLayout.html?vue&type=template&id=34f5d12e&scoped=true&ts=true&external"
import script from "./ExternalLayout.vue?vue&type=script&lang=ts"
export * from "./ExternalLayout.vue?vue&type=script&lang=ts"

import "./ExternalLayout.scss?vue&type=style&index=0&id=34f5d12e&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f5d12e"]])

export default __exports__